import { Row, Col, Button, Divider, Avatar, Tooltip, Pagination, Spin, Popover, Empty, DatePicker, Select, Input, Form } from "antd";
import { EditOutlined, DeleteOutlined, UserOutlined, InboxOutlined, FilterOutlined, SearchOutlined, ReloadOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { FiClock, FiCalendar, FiMapPin } from "react-icons/fi";

import Table from "../components/Table.js";
import Create from "../components/Game/Create.js";
import Update from "../components/Game/Update.js";
import Delete from "../components/Game/Delete.js";

import endpoints from "../utils/endpoints.js";
import { useForm } from "antd/es/form/Form.js";

import "react-quill/dist/quill.snow.css";
import config from "../utils/config.js";
import Settings from "../components/Game/Settings.js";

function Game() {
  const [data, setData] = useState([]);
  const [settings, setSettings] = useState({});
  const [tableData, setTableData] = useState([]);

  const [selectedData, setSelectedData] = useState({});

  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenSettings, setIsOpenSettings] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    setIsLoading(true);
    axios
      .get(endpoints.game.read)
      .then((res) => {
        console.log(res);
        setData(res.data[0]);
        setSettings(res.data[1][0]);

        prepareData(res.data[0]);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function prepareData(arr) {
    setIsLoading(true);

    let auxArray = [];

    for (let i = 0; i < arr.length; i++) {
      let auxAnswers = arr[i].answers ? JSON.parse(arr[i].answers) : [];
      console.log(auxAnswers);
      let aux = {
        key: i,
        img: <img src={`${config.server_ip}media/${arr[i].img}`} className="max-w-[100px]" />,
        answers: auxAnswers.map((a) => (
          <div className={`flex p-1`}>
            {a.title}
            {a.is_correct ? (
              <span className="ml-2">
                <CheckCircleOutlined className="text-green-400" />
              </span>
            ) : null}
          </div>
        )),
        actions: (
          <div className="flex justify-end items-center">
            <Button className="flex items-center justify-center mr-2" type="primary" onClick={() => openUpdate(arr[i])}>
              <EditOutlined />
            </Button>
            <Button className="flex items-center justify-center" danger onClick={() => openDelete(arr[i])}>
              <DeleteOutlined />
            </Button>
          </div>
        ),
      };

      auxArray.push(aux);
    }

    setTableData(auxArray);
    setIsLoading(false);
  }

  function openCreate() {
    setIsOpenCreate(true);
  }

  function openUpdate(item) {
    setSelectedData(item);
    setIsOpenUpdate(true);
  }

  function openDelete(data) {
    setSelectedData(data);
    setIsOpenDelete(true);
  }

  function openSettings() {
    setIsOpenSettings(true);
  }

  function closeAction(f) {
    if (f) getData();
    setSelectedData({});
    setIsOpenCreate(false);
    setIsOpenCreate(false);
    setIsOpenUpdate(false);
    setIsOpenSettings(false);
    getData();
  }

  return (
    <div className="dashboard-page">
      <Create open={isOpenCreate} close={closeAction} />
      <Update data={selectedData} open={isOpenUpdate} close={closeAction} />
      <Delete data={selectedData} open={isOpenDelete} close={closeAction} />
      <Settings data={settings} open={isOpenSettings} close={closeAction} />
      <Row className="dashboard-title-row">
        <Col span={4} className="flex justify-start items-center">
          <h3 className="dashboard-title">Jogo</h3>
        </Col>
        <Col span={20} className="flex justify-end items-center">
          <Button size="large" className="mr-2 flex justify-center items-center" onClick={getData}>
            <ReloadOutlined />
          </Button>
          <Button size="large" onClick={openSettings} className="mr-2">
            Definições
          </Button>
          <Button type="primary" size="large" onClick={openCreate}>
            Adicionar pergunta
          </Button>
        </Col>
      </Row>
      <Divider />
      <Spin spinning={isLoading}>
        <Row className="dashboard-content-row">
          <Col span={24}>
            <Table
              dataSource={tableData}
              columns={[
                {
                  title: "",
                  dataIndex: "img",
                  key: "img",
                  width: "120px",
                },
                {
                  title: "Respostas",
                  dataIndex: "answers",
                  key: "answers",
                },
                {
                  title: "",
                  dataIndex: "actions",
                  key: "actions",
                },
              ]}
            />
          </Col>
        </Row>
      </Spin>
    </div>
  );
}

export default Game;
